import { EvaluationResult } from './evaluationTypes'

export const criterionLabel:Record<string,string>={best:'Mejor válido',mean:'Media de válidos',manual:'Selección manual'}
export const directionLabel:Record<string,string>={lower:'Menor es mejor',higher:'Mayor es mejor',neutral:'Cambio neutral'}
export const sideLabel:Record<string,string>={none:'No aplica',left:'Izquierda',right:'Derecha'}
export const trackingLabel:Record<string,string>={active:'Activo',paused:'Pausado',archived:'Archivado'}

export function parseMeasurement(text: string, precision: number): number | null {
  const normalized = text.trim().replace(',', '.')
  if (!normalized) return null
  if (!/^\d+(\.\d+)?$/.test(normalized) || (normalized.split('.')[1]?.length || 0) > precision) throw new Error(`Usa un número con hasta ${precision} decimales, sin separadores de miles.`)
  const value = Number(normalized)
  if (!Number.isFinite(value)) throw new Error('Número no válido')
  return value
}
export function compatible(a: EvaluationResult, b: EvaluationResult): boolean {
  return a.athlete_id === b.athlete_id && a.team_id === b.team_id && a.protocol_id === b.protocol_id && a.side === b.side && a.method === b.method && a.device === b.device
}
export function difference(a: EvaluationResult, b: EvaluationResult) {
  if (!compatible(a, b) || a.representative === null || b.representative === null) return null
  const delta = b.representative - a.representative
  return { delta, percent: a.protocol.kind === 'performance' && a.representative > 0 ? delta * 100 / a.representative : null,
    trend: a.protocol.direction === 'neutral' || delta === 0 ? 'Cambio neutral' : (delta > 0) === (a.protocol.direction === 'higher') ? 'Mejora' : 'Empeoramiento' }
}
export function csvCell(value: unknown): string {
  let text = value === null || value === undefined ? '' : String(value)
  if (/^[\s]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text
  return '"' + text.replace(/"/g, '""') + '"'
}
export function evaluationCsv(rows: EvaluationResult[]): string {
  const columns = ['Jugador','Concentración','Evaluación','Fecha UTC','Indicador','Valor','Unidad','Protocolo','Versión','Método','Dispositivo','Lado','Responsable','Compartido','Observaciones compartidas','Intentos']
  return '\uFEFF' + [columns.map(csvCell).join(';'), ...rows.map(r => [r.athlete_name,r.camp_name,r.session_name,r.measured_at,r.protocol.name,r.representative,r.protocol.unit,r.protocol.protocol,r.protocol.version,r.method,r.device,r.side,r.responsible_name,r.published?'Sí':'No',r.shared_notes,JSON.stringify(r.attempts)].map(csvCell).join(';'))].join('\r\n')
}
